module.exports = __webpack_public_path__ + "static/media/esfoliante.f7102dd3.png";